// libs
import Swiper from '../../libs/swiper-6.6.2/swiper-bundle';

window.$ = jQuery;
window.Swiper = Swiper;

import { SliderCoursesBrief } from '../_components/_slider-courses-brief';
import { LobbyTeachingSlider } from '../_components/_lobby-teaching-slider';
import { SliderReviews } from "../_components/_slider-reviews";
import { Accordion } from "../_components/_accordion";
import { SliderArticles } from "../_components/_slider-articles";
import { SliderSeo, InitStickySliderSeo } from "../_components/_slider-seo";
import { AnchorMenuSticky } from "../_components/_anchor-menu";
import { ScrollLinksActions } from "../_components/_scroll-link";
import { LobbyListSlider } from '../_components/_lobby-list-slider';
import { VisibleCtaBottomNav } from '../_components/_cta-bottom-nav';
import { testDrive } from "../_components/mailchimp-formhandlers/_test-drive";
import { AnchorLinkScrolling } from "../_components/_anchor-link-scrolling";
import { PopupBanner }        from "../_components/_popup-banner";
import { VideoFrame } from "../_components/_video-frame";
import { CoursePopup } from "../_components/_course-link";

$(document).ready(function () {
  testDrive();
  PopupBanner();

  //SECTION Lobby Hero 
  VisibleCtaBottomNav();

  // SECTION Lobby Highlights
  LobbyListSlider();

  // SECTION Lobby Courses
  SliderCoursesBrief();
  AnchorLinkScrolling();

  // SECTION Lobby Teaching
  LobbyTeachingSlider();

  // COMMON SECTIONS
  SliderReviews();
  Accordion();
  SliderArticles();
  SliderSeo();
  InitStickySliderSeo();

  // STICKY MENU
  AnchorMenuSticky();
  ScrollLinksActions();
  VideoFrame();
  CoursePopup();

});

